import { Component, OnInit } from '@angular/core';
import { AppMetadataHandler } from 'app';
import { SLADashboardService } from './sla-dashboard.service';
import { CommonUtilty } from '../../../BaseFramework/core/utilities/commonUtility';
import { NzMessageService } from 'ng-zorro-antd/message';
import { InvestigationService } from 'app/BaseFramework/core/http/investigation.service';
import { environment } from 'environments/environment';
import { single } from './sla-data'


declare const FunnelGraph: any;

@Component({
  selector: 'app-sla-dashboard',
  templateUrl: './sla-dashboard.component.html',
  styleUrls: ['./sla-dashboard.component.scss']
})
export class SLADashboardComponent implements OnInit {

  selectedTeamMember = 'Ninad Kulkarni';

  totalSLA = [
    {
      "name": "Pre Auth Registration",
      "value": '6 Hrs'
    },
    {
      "name": "Health Claim Registration",
      "value": '8 Hrs'
    },
    {
      "name": "New Proposal Registration",
      "value": '5 Hrs'
    }
  ];

  refreshPieChart = true;

  constructor(
    public appMetadataHandler: AppMetadataHandler,
    public SLADashboardService:SLADashboardService,
    private commonUtility: CommonUtilty,
    private message: NzMessageService,      
    private investigationService: InvestigationService,
  ) {
    Object.assign(this, { single });
  }

  dashboardDateRange: any = [];
  environment = environment;

  ngOnInit() {
    this.setDefaultDateRange();
    this.refreshPieChart = false 
    setTimeout(() => {
      this.refreshPieChart = true
    }, 300);
   }

   setDefaultDateRange(){
    var currentDate = new Date();
    var PreviousYrDate = currentDate.setFullYear(currentDate.getFullYear() - 1);
    this.dashboardDateRange = [new Date(PreviousYrDate), new Date()];
   }
  /* UI :: IMPORTANT NOTE !!!
  * The UI widgets (those with ngx-charts) must be initialized AFTER the view has loaded
  * to prevent erratic display behaviour w.r.t rendering
  */

  widgetReady:boolean = false;
  monthlyOrWeekly:string = 'monthly';

  ngAfterViewInit(): void {
    this.widgetReady=true;
    // this.fetchCardsData(this.dashboardDateRange);
    // setTimeout(()=>{ this.initFunnel() },850);
    // this.fetchMonthlyWeeklyReport();
    // this.widgetReady=true;
  }

  /* Date */

  onDashboardDateRangeSelection(e) {
    this.fetchCardsData(e);
  }

  fetchCardsData(selectedDateRange){
    this.SLADashboardService.fetchCardsData(selectedDateRange).subscribe(resp => {
      // extract data and pass to funnel graph
    });
  }

  fetchMonthlyWeeklyReport(){
    this.SLADashboardService.fetchMonthlyWeeklyReport().subscribe(resp => {
      
    });
  }

  fraudReasonsList = [];
  claimNumberSearch : string;
  fraudIO = {};
  displayFraudDataCards: boolean = false;
  
  searchClaim(){
    this.displayFraudDataCards = true;
    this.getColorCode();      
   
    this.fraudReasonsList.push('Agent PAN number is not black listed.');
    this.fraudReasonsList.push('Primary hospital and claim hospitalization network is present.');
    this.fraudReasonsList.push('Claim hospitalization network is present.');
    this.fraudReasonsList.push('No negative postal code and Claim hospitalization network is present.');
    this.fraudReasonsList.push('Primary hospital is present.');
    
    this.SLADashboardService.fetchFWADataAgainstClaimNumber(this.claimNumberSearch).subscribe(resp => {
      this.fraudIO = this.commonUtility.isArrayIterable(resp) ? resp.find(e=> true) : resp;

      if (environment && environment.demo) {
        this.fraudIO['predictionProbabilityPercent'] = this.generateRandom();
      }
      //this.displayFraudDataCards = true;
      // this.getColorCode();      
      // for(let i=1; i <=5; i++){
      //   if(this.fraudIO['Reason '+i]){
      //     this.fraudReasonsList.push(this.fraudIO['Reason '+i]);
      //   }
      // }
    });
  }

  generateRandom(maxLimit = 100){
    let rand = Math.random() * maxLimit;  
    rand = Math.floor(rand); 
    return rand;
  }

  getColorCode(){
    if(this.fraudIO){
      let val = this.fraudIO['predictionProbabilityPercent'];
      switch(true){
        case (val < 25):
          this.fraudIO['color'] = '#55c120';
          break;
        case (val > 25 && val < 75):
          this.fraudIO['color'] = '#ef9f27';
          break;
        case (val > 75):
          this.fraudIO['color'] = '#d52b2b';
          break;
        default:
          this.fraudIO['color'] = '#1890ff';
          break;
      }
    }
  }

  /* Functions for getting Gauge values */
  getFraudPropensity = (percent: number) => `${percent}`;
  getRiskValue = (percent: number) => percent > 70 ? 'High' : percent < 70 && percent > 25 ? 'medium' : 'Low';

  selectedTrigger:string;
  searchFromTrigger: string;

  fetchTriggers(){
    this.SLADashboardService.fetchTriggersData(this.selectedTrigger).subscribe(resp => {
      
    });
  }
  passwordVisible: boolean = false;
  isRetrainModelPopup : boolean = false;
  enteredOTP;
  showRetrainPopup(){
    this.isRetrainModelPopup = true;
  }

  callToRetrainModel(){
    if(this.enteredOTP == this.SLADashboardService.masterData){

      this.currentRetrainStatus = "Training in Progress";
      this.trainingInProgress = true;
      this.message.create('success', `Training started successfully!`);
      this.isRetrainModelPopup = false;

      let request = {
        "product_type": "HEALTH_PreAuth",
        "business_process": "FWARISKANALYSIS",
        "module_name": "RIGHTCREDIT"
      }

      this.investigationService.retrainingFWA(request).subscribe(resp => {
        this.currentRetrainStatus = resp;  
        this.trainingInProgress = false;      
      });
    }else{
      this.message.create('error', `Invalid OTP`);
    }
  }

  cancelRetrainModelPopup(){
    this.isRetrainModelPopup = false;
  }

  currentRetrainStatus = 'Last training done on 22 Apr 2022'; // another value will be 'Last trained on *some date*'
  trainingInProgress: boolean = false;
  /* ====================================== */
  /* UI COLOR SCHEME SELECTION AND SETTING  */
  colorScheme = {
    name: 'horizon',
    selectable: true,
    group: 'Continuous',
    domain: ["#647c8a", "#3f51b5", "#2196f3", "#00b862", "#85a711", "#b1bd0d", "#5797cb", "#d276be", "#ac4632", "#0ba3d4", "#647c8a", "#3f51b5", "#2196f3", "#00b862", "#85a711", "#b1bd0d"]
  };

  /* ====================================== */
  /* Data */
  
  dataCARDS: any[] = [
    {
      "name": "Policies",
      "value": "12,026",
      "breakup": [
        {key: "Direct Sales", value: "2,020"},
        {key: "Agents", value: "4,005"},
        {key: "Other Channels", value: "6,001"},
      ]
    },
    {
      "name": "Claims",
      "value": "4,064",
      "breakup": [
        {key: "Claims", value: "2,890"},
        {key: "Pre-Auth", value: "1,174"},
      ]
    },
    {
      "name": "FWA Triggered",
      "value": "1,071",
      "breakup": [
        {key: "High Risk", value: "310"},
        {key: "Medium Risk", value: "472"},
        {key: "Low Risk", value: "289"},
      ]
    },
    {
      "name": "Investigation",
      "value": "662",
      "breakup": [
        {key: "Closed", value: "426"},
        {key: "Work-in-progress", value: "236"},
      ]
    },
    {
      "name": "Fraudulent Claims",
      "value": "152",
      "breakup": [
        {key: "Hospital", value: "82"},
        {key: "Pharmacy", value: "46"},
        {key: "Advisor", value: "24"},
      ]
    }
  ];

  colorScheme1 = {
    domain: ['#5AA454', '#E44D25', '#CFC0BB', '#7aa3e5', '#a8385d', '#aae3f5']
  };

  monthlyWeeklyReport = {
    monthly: [
      {
        name: 'Months',
        series:[
          { name: "Jan", value: 366 },
          { name: "Feb", value: 543 },
          { name: "March", value: 58 },
          { name: "April", value: 3465 },
          { name: "May", value: 25 },
          { name: "June", value: 383 },
          { name: "July", value: 457 },
          { name: "Aug", value: 100 },
          { name: "Sept", value: 453 },
          { name: "Oct", value: 996 },
          { name: "Nov", value: 357 },
          { name: "Dec", value: 141 }
        ]
      }
    ],
    daily: [
      {
        name: 'Days',
        series:[
          { name: "Monday", value: 12 },
          { name: "Tuesday", value: 22 },
          { name: "Wednesday", value: 66 },
          { name: "Thursday", value: 93 },
          { name: "Friday", value: 44 },
          { name: "Saturday", value: 63 },
          { name: "Sunday", value: 22 }
        ]
      }
    ]
  }

  MLPredictionVsActualResult = [
    {
      "name": "Machine Learning Prediction",
      "series": [
        {
          "name": "2018",
          "value": 41300
        },
        {
          "name": "2019",
          "value": 38977
        },
        {
          "name": "2020",
          "value": 29088
        },
        {
          "name": "2021",
          "value": 45234
        },
        {
          "name": "2022",
          "value": 32000
        }
      ]
    },
  
    {
      "name": "Actual Result",
      "series": [
        {
          "name": "2018",
          "value": 48000
        },
        {
          "name": "2019",
          "value": 40867
        },
        {
          "name": "2020",
          "value": 42900
        },
        {
          "name": "2021",
          "value": 45600
        },
        {
          "name": "2022",
          "value": 31900
        }
      ]
    }
  ];


  /* Data */
  clusters = [
    { id: 1, name: "Hospital", type:"cluster", severity:"high", contribution: 32},
    { id: 2, name: "Policy and Insured", type:"cluster", severity:"medium", contribution: 26 },
    { id: 3, name: "Advisor", type:"cluster", severity:"medium", contribution: 12 },
    { id: 4, name: "Sales Person", type:"cluster", severity:"low", contribution: 8 },
    { id: 5, name: "Diagnosis Grouper", type:"cluster", severity:"low", contribution: 3 },
  ]
  // dataSet = DATA_DFC.top;

  /* Search */
  searchTerm:string = '';
  isSearching = false;
  performSearch() {
    this.isSearching = true;
    this.dataSet = this.Shuffle(this.dataSet); /* Fake sort */
    this.dataSet = this.dataSet.sort(() => Math.random() - 0.15 ); /* Fake sort */
    setTimeout(()=>{this.isSearching = false;},800);
  }
  Shuffle(o) {
    for(let j, x, i = o.length; i; j = parseInt(String(Math.random() * i)), x = o[--i], o[i] = o[j], o[j] = x);
    return o;
  };


  dataSet = [
    {"cluster":"Hospital","message":"Higher Rejections from this Provider","invConfirmation":"true","invStatus":"na","invRemarks":"-","probability":"Higher the rejection at a Provider level, higher is the probability of next claim being rejected","scenario":"Past claim experience Status like with minimum number of claims like 5 or 10, etc  \n1. Approved \n2. Rejected \n3. Under Query \n\nDefine threshold overall and then compare within also\nThis should vary at Provider Type also like different threshold for Primary, Secondary and Tertiary Providers."},
    {"cluster":"Hospital","message":"Previously identified Fraudulent claims from this Provider","invConfirmation":"true","invStatus":"na","invRemarks":"-","probability":"Even if 1 claim rejected due to this, higher is the probability","scenario":"Past claim experience in terms of any claim rejected due to fraud, waste and or abuse\nIf yes, high score to be given"},
    {"cluster":"Hospital","message":"From Caution Provider","invConfirmation":"true","invStatus":"fraud","invRemarks":"Checked and verified","probability":"Higher","scenario":"Caution Hospital"},
    {"cluster":"Hospital","message":"Excess Length of Stay (LOS)","invConfirmation":"true","invStatus":"fraud","invRemarks":"Checked and verified","probability":"Higher the LOS as compared to average, higher is the probability of waste","scenario":"Average Length of Stay (LOS) comparison\nFor the same ICD and CPT / PCS Grouper"},
    {"cluster":"Hospital","message":"Excess claimed amount","invConfirmation":"true","invStatus":"fraud","invRemarks":"Checked and verified","probability":"Higher the ACS as compared to average, higher is the probability of waste","scenario":"Average Claim Size (ACS) comparison\nFor the same ICD and CPT / PCS Grouper"},
    {"cluster":"Advisor","message":"Higher Loss ratio of this agent","invConfirmation":"pending","invStatus":"pending","invRemarks":"-","probability":"Higher the Loss ratio, higher is chance of fraud","scenario":"Loss ratio of this Advisor\nRetail - At a Portfolio level \nGroup - At a advisor and then at a Group level. \n \nDefine threshold overall and then compare within also"},
    {"cluster":"Advisor","message":"Higher Frequency from this agent","invConfirmation":"pending","invStatus":"pending","invRemarks":"-","probability":"Higher the frequency, higher is chance of fraud","scenario":"Frequency\nRetail - At a Portfolio level \nGroup - At a advisor and that Group level\n\nDefine Threshold"},
    {"cluster":"Advisor","message":"Higher claims of Agent in this Provider","invConfirmation":"pending","invStatus":"pending","invRemarks":"-","probability":"Higher","scenario":"Advisor claiming from the same Provider \nThreshold to be defined"},
    {"cluster":"Policy and Insured","message":"Claim from insured early on","invConfirmation":"true","invStatus":"non-fraud","invRemarks":"Checked and verified ","probability":"Lower the Tenure, higher is the probability","scenario":"Tenure"},
    {"cluster":"Policy and Insured","message":"Claim from Insured belonging to a pin code with high fraudulent claims","invStatus":"non-fraud","invConfirmation":"true","invRemarks":"Checked and verified ","probability":"Understand which pincodes are highest or higher conducting fraud","scenario":"Loss Location"},
    {"cluster":"Policy and Insured","message":"Claim from Insured belonging to a pin code with high rejection ratio","invStatus":"na","invConfirmation":"false","invRemarks":"-","probability":"Understand which pincodes are highest Rejection ratio","scenario":"Loss Location"}
  ]

  /* Data */
  slaDataSet = [
    {
      name : 'Ninad Kulkarni',
      claimValue : '42,50,800',
      tasks: 12,
      completed: 5,
      pendingInt: 2,
      pendingAdj: 2,
      pendingPay: 3,
      sla: 5,
    },
    {
      name : 'Abhishek Lamrood',
      claimValue : '42,50,800',
      tasks: 15,
      completed: 7,
      pendingInt: 4,
      pendingAdj: 2,
      pendingPay: 2,
      sla: 7
    },
    {
      name : 'Umesh Ravariya',
      claimValue : '42,50,800',
      tasks: 11,
      completed: 4,
      pendingInt: 3,
      pendingAdj: 3,
      pendingPay: 1,
      sla: 4
    },
    {
      name : 'Pratima',
      claimValue : '42,50,800',
      tasks: 21,
      completed: 15,
      pendingInt: 2,
      pendingAdj: 1,
      pendingPay: 2,
      sla: 6
    },
    {
      name : 'Mohit',
      claimValue : '42,50,800',
      tasks: 18,
      completed: 6,
      pendingInt: 5,
      pendingAdj: 4,
      pendingPay: 3,
      sla: 5
    },
  ];

  /* Data */
  caseDataSet = [
    {
      name : 'PA0000684',
      claimValue : '6,40,800',
      status: 'Pending Claim Registration',
      color: 'green',
      holdingTm: 2,
      pendingTm: 5,
      currencyCd: 'INR'
    },
    {
      name : 'PA0000685',
      claimValue : '3,00,800',
      status: 'Pending Claim Registration',
      color: 'orange',
      holdingTm: 1,
      pendingTm: 4,
      currencyCd: 'INR'
    },
    {
      name : 'PA0000690',
      claimValue : '7,10,400',
      status: 'Pending Claim Adjudication',
      color: 'red',
      holdingTm: 0,
      pendingTm: 2,
      currencyCd: 'INR'
    },
    {
      name : 'PA0000691',
      claimValue : '3,50,400',
      status: 'Pending Claim Adjudication',
      color: 'orange',
      holdingTm: 4,
      pendingTm: 3,
      currencyCd: 'INR'
    },
    {
      name : 'PA0000686',
      claimValue : '4,50,000',
      status: 'Pending Claim Payout',
      color: 'orange',
      holdingTm: 3,
      pendingTm: 2,
      currencyCd: 'INR'
    },
    {
      name : 'PA0000679',
      claimValue : '10,00,000',
      status: 'Pending Claim Payout',
      color: 'green',
      holdingTm: 4,
      pendingTm: 8,
      currencyCd: 'INR'
    },
    {
      name : 'PA0000693',
      claimValue : '12,00,000',
      status: 'Pending Claim Payout',
      color: 'green',
      holdingTm: 5,
      pendingTm: 9,
      currencyCd: 'INR'
    },
  ];

  agentSearch() {
    this.isSearching = true;
    this.dataSet = this.Shuffle(this.dataSet); /* Fake sort */
    this.dataSet = this.dataSet.sort(() => Math.random() - 0.15 ); /* Fake sort */
    setTimeout(()=>{this.isSearching = false;},800);
  }

  /* DUMMY ; change logic */
  getUserLoad(u) {
    if(u.completed/u.tasks*100 < 40) return 'low';
    else if(u.completed/u.tasks*100 < 60) return 'med';
    else return 'hig';
  }

  graphHeight = 350;
  graph = null;
  initFunnel() {
    // Source: https://github.com/greghub/funnel-graph-js
    this.graph = new FunnelGraph({
      direction: 'horizontal',
      height: this.graphHeight,
      container: '.funnel-container',
      gradientDirection: 'vertical',
      data: {
        labels: ['Policies', 'Claims', 'FWA Triggered', 'Investigation', 'Fraudulent'],
        // labels: ['Policies', 'FWA Triggered'],
        subLabels: ['Direct','Agents','Other channels'],
        colors: [
          ['rgb(100, 124, 138)', 'rgb(114,151,169)', 'rgb(75,105,117)'],
          ['#03a9f4','#32bbf1'],
          ['rgb(63, 81, 181)','rgb(93,111,239)','rgb(81,102,222)'],
        ],
        values: [
          [2020, 4005, 6001], // Policies via ['Direct','Agents','Other channels']
          [1602, 1200, 1262], // Claims
          [625, 157, 289], // Triggered
          [347, 116, 199], // Investigation
          [36, 57, 59], // Fraudulent
        ]
        // values: [
        //   [2020, 4005, 6001], // Policies via ['Direct','Agents','Other channels']
        //   [625, 157, 289], // Triggered
        // ]
      },
      displayPercent: true,
    });
    this.graph.draw();
  }

  // total sla

  single: any[];
  view: any[] = [700, 400];

  // options
  gradient: boolean = true;
  showLegend: boolean = false;
  showLabels: boolean = true;
  isDoughnut: boolean = false;
  legendPosition: string = 'below';

  loading = false;
  showXAxis = true;
  showXAxisLabel = true;
  xAxisLabel = 'Vertical';
  showYAxis = true;
  showYAxisLabel = true;
  yAxisLabel = 'Sales';

  colorSchemeSLA = {
    domain: ['#A10A28', '#C7B42C', '#AAAAAA']
  };

  multi = [
    {
      "name": "SLA met for Proposals",
      "series": [
        {
          "name": "Data Entry",
          "value": 1203
        },
        {
          "name": "Underwriting",
          "value": 789
        }
      ]
    },
    {
      "name": "SLA missed for Proposals",
      "series": [
        {
          "name": "Data Entry",
          "value": 187
        },
        {
          "name": "Underwriting",
          "value": 87
        }
      ]
    }

  ];


  onSelect(data): void {
    console.log('Item clicked', JSON.parse(JSON.stringify(data)));
  }

  onActivate(data): void {
    console.log('Activate', JSON.parse(JSON.stringify(data)));
  }

  onDeactivate(data): void {
    console.log('Deactivate', JSON.parse(JSON.stringify(data)));
  }
  

}

